import { render } from "./front_banner.vue?vue&type=template&id=c0fc84c2&scoped=true"
import script from "./front_banner.vue?vue&type=script&lang=js"
export * from "./front_banner.vue?vue&type=script&lang=js"

import "./front_banner.vue?vue&type=style&index=0&id=c0fc84c2&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fc84c2"]])

export default __exports__